import { createFileRoute } from "@tanstack/react-router";

import SuppliersPage from "@/features/supplier-master/pages/suppliers";

export const Route = createFileRoute("/(app)/dashboard/suppliers")({
  component: () => <SuppliersPage />,
});
